// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__29h55","inner":"Footer_inner__Bd7xa"};